/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Ramachandra Gupta, Vusirikala; Thomas Barry

 Description:
 */
import InterdictionRecord from '../../records/InterdictionRecord';
import InterdictionResponseRecord from '../../records/InterdictionResponseRecord';
import * as actions from './actions';

var interdictionReducer = function interdictionReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new InterdictionRecord();

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      _ref$payload = _ref.payload,
      payload = _ref$payload === void 0 ? {} : _ref$payload;

  switch (type) {
    case actions.INTERDICTION_INIT:
      return new InterdictionRecord({
        active: true,
        interdiction: payload.interdiction,
        postSuccessAction: payload.postSuccessAction,
        postSuccessPayload: payload.postSuccessPayload,
        onResume: payload.onResume,
        onCancel: payload.onCancel,
        hardStop: false,
        blockFailureMessage: ''
      });

    case actions.INTERDICTION_END:
      return new InterdictionRecord({
        active: false
      });

    case actions.INTERDICTION_CLEAR_RESPONSE:
      return new InterdictionRecord({
        response: {},
        failureMessage: {}
      });

    case actions.INTERDICTION_SET_RESPONSE:
      return state.merge({
        response: new InterdictionResponseRecord(payload)
      });

    case actions.INTERDICTION_SET_FAILURE_MESSAGE:
      {
        var status = payload.status;

        switch (status) {
          case 'VALIDATION_FAILURE':
          case 'AUTH_FAILED':
          case 'EXPIRED':
            return state.merge({
              failureMessage: payload.status
            });

          case 'SYSTEM_DOWN':
            if (payload.message === 'label.error.otp.sorDown') {
              return state.merge({
                hardStop: true,
                blockFailureMessage: payload.message,
                failureMessage: ''
              });
            }

            return state.merge({
              failureMessage: payload.message
            });

          default:
            return state.merge({
              hardStop: true,
              blockFailureMessage: payload.status,
              failureMessage: ''
            });
        }
      }

    case actions.INTERDICTION_SET_OCS_FAILURE_MESSAGE:
      {
        return state.merge({
          ocsFailureMessage: payload
        });
      }

    case actions.INTERDICTION_SET_OTP_VIEW_NAME:
      {
        return state.merge({
          otpViewName: payload
        });
      }

    case actions.INTERDICTION_SET_OCS_VIEW_NAME:
      {
        return state.merge({
          ocsViewName: payload
        });
      }

    case actions.INTERDICTION_CLEAR_FAILURE_MESSAGE:
      {
        return state.merge({
          failureMessage: ''
        });
      }

    case actions.INTERDICTION_SET_OOW_QUESTION:
      {
        return new InterdictionRecord({
          active: true,
          interdiction: payload,
          postSuccessAction: state.postSuccessAction
        });
      }
    // Auth Hierarchy Flow

    case actions.INTERDICTION_SET_AUTH_FAILURE_MESSAGE:
      {
        var errorType = payload.errorType,
            showErrorMessageLocation = payload.showErrorMessageLocation,
            deliveryMethod = payload.deliveryMethod,
            messageId = payload.messageId;
        var hardStop = showErrorMessageLocation && showErrorMessageLocation === 'MODAL';
        var message = "core.interdiction.auth.".concat(errorType || messageId || 'SYSTEM_DOWN');

        if (errorType === 'AA_OTP_CODE_DELIVERY_ERROR') {
          message += ".".concat(deliveryMethod);
        }

        if (hardStop) {
          return state.merge({
            hardStop: hardStop,
            blockFailureMessage: message,
            failureMessage: '',
            authView: 'hardStop'
          });
        }

        return state.merge({
          hardStop: hardStop,
          blockFailureMessage: '',
          failureMessage: message
        });
      }

    case actions.INTERDICTION_INIT_AUTH_VIEW:
      {
        var authView = payload.authView,
            authMethodCount = payload.authMethodCount;
        return state.merge({
          authView: authView,
          authMethodCount: authMethodCount
        });
      }

    case actions.INTERDICTION_SET_AUTH_VIEW:
      {
        var selectedContactInfo = payload.selectedContactInfo,
            _authView = payload.authView;
        return state.merge({
          authView: _authView,
          selectedContactInfo: selectedContactInfo
        });
      }

    case actions.INTERDICTION_AUTH_CLEAR_RESPONSE:
      {
        return state.merge({
          response: null
        });
      }

    case actions.INTERDICTION_AUTH_SET_OOW_VIEW:
      {
        var _authView2 = payload.authView,
            oowQuestion = payload.oowQuestion;
        return state.merge({
          authView: _authView2,
          oowQuestion: oowQuestion
        });
      }

    case actions.INTERDICTION_AUTH_SET_OOW_QUESTION:
      {
        return state.merge({
          oowQuestion: payload
        });
      }

    default:
      return state;
  }
};

export default interdictionReducer;